import { render, staticRenderFns } from "./CreateMetaInsightsChannel.vue?vue&type=template&id=65516d24&scoped=true"
import script from "./CreateMetaInsightsChannel.vue?vue&type=script&lang=js"
export * from "./CreateMetaInsightsChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateMetaInsightsChannel.vue?vue&type=style&index=0&id=65516d24&prod&lang=scss&scoped=true"
import style1 from "./CreateMetaInsightsChannel.vue?vue&type=style&index=1&id=65516d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65516d24",
  null
  
)

export default component.exports